
    var riot = require('riot')
    //src: starling/src/tags/modal-share/panel-embed.html
riot.tag2('panel-embed',
  '<p class="panel-embed_content">Paste the following in the HTML of your website</p> <div class="link-panel"> <header if="{canModify && !viewLinkAvailable()}" class="link-panel_header"> <h3 class="link-panel_header_title">View-only link must be enabled for people to see your map</h3> <button class="Button Button--Small" onclick="{enablePublicViewLink}"> Turn on view-only link </button> </header> <textarea ref="textarea" readonly class="link-panel_body link-panel_code" onclick="{selectAll}">&lt;iframe src=&quot;{viewUrl()}&quot; width=&quot;700&quot; height=&quot;500&quot;&gt;&lt;/iframe&gt;</textarea> <footer class="link-panel_footer"> <button class="link-panel_footer_button" onclick="{copyLink}"> <svg ref="copyIcon" class="link-panel_footer_button_icon"> <use xlink:href="#code-icon"></use> </svg> <span ref="copyButton">Copy code snippet</span> </button> </footer> </div>',
  '',
  'class="modal-share_panel panel-embed"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util.js');

var _opts = opts,
    canvas = _opts.canvas;
var access = canvas.access,
    people = canvas.people;

this.canModify = false;

if (people) {
  var currentUser = people.currentUser;

  if (currentUser && currentUser.id === people.owner.id) {
    this.canModify = true;
  }
}

this.viewUrl = function () {
  return canvas.config.site_url + '/maps/' + canvas.access.publicIdentifier;
};

this.selectAll = function (_ref) {
  var target = _ref.target;

  target.select();
};

this.copyLink = function () {
  var _refs = _this.refs,
      copyButton = _refs.copyButton,
      copyIcon = _refs.copyIcon;
  var textContent = copyButton.textContent;

  copyIcon.style.display = 'none';
  copyButton.textContent = 'Copied!';

  setTimeout(function () {
    copyIcon.style.display = 'block';
    copyButton.textContent = textContent;
  }, 3000);

  (0, _util.copyToClipboard)({ text: _this.refs.textarea.value });
};

this.viewLinkAvailable = function () {
  return access.enablePublicViewLink;
};

this.enablePublicViewLink = function () {
  access.enablePublicViewLink = !_this.viewLinkAvailable();
  _this.updateMapShareSettings({ field: 'view', on: _this.viewLinkAvailable() });
  _this.update();
};

this.updateMapShareSettings = function (_ref2) {
  var field = _ref2.field,
      on = _ref2.on;

  operation.updateMapShareSettings({
    field: 'enable_public_' + field + '_link',
    value: on ? 1 : 0,
    onFailure: function onFailure() {
      console.error('failed to update ' + field + ' link settings');
    }
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('panel-embed')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-share/panel-embed.html
// module id = 774
// module chunks = 0